<!--
  Copyright 2025 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="general-access-control-container">
  <div class="general-access-icon" [ngSwitch]="selectedGeneralAccess">
    <mat-icon>
      {{ generalAccessLabels.get(selectedGeneralAccess)?.icon ?? generalAccessLabels.get(SurveyGeneralAccess.RESTRICTED)?.icon }}
    </mat-icon>
  </div>

  <div class="general-access-control">
    <mat-select
      class="general-access-select"
      [(value)]="selectedGeneralAccess"
      [hideSingleSelectionIndicator]="true"
      (selectionChange)="changeGeneralAccess($event.value)"
    >
      <mat-select-trigger class="task-label">
        <div>{{generalAccessLabels.get(selectedGeneralAccess)?.label}}</div>
      </mat-select-trigger>

      <mat-option *ngFor="let generalAccess of generalAccessKeys" [value]="generalAccess">
        <div class="task-label">{{generalAccessLabels.get(generalAccess)?.label}}</div>
      </mat-option>
    </mat-select>

    <div class="general-access-description">
      {{generalAccessLabels.get(selectedGeneralAccess)?.description}}
    </div>
  </div>

  <ground-copy-survey-controls
    *ngIf="selectedGeneralAccess === SurveyGeneralAccess.UNLISTED"
    [surveyId]="survey()?.id || ''"
  ></ground-copy-survey-controls>
</div>
